// Custom hook to POST schedule and set 'outside' state
import { useState, useCallback } from 'react';
import useServerApi from '../../../hooks/useServerApi';

export function useScheduleCheck(agentId) {
  const [scheduleStatus, setScheduleStatus] = useState(null);
  const [{ post }] = useServerApi();

  // values: schedule object to send
  const checkSchedule = useCallback(async (values) => {
    try {
      const [success, responseData] = await post(`/rest_endpoints/${agentId}/call_transfers/current_schedule_check`, values);
      if (success && responseData) {
        setScheduleStatus(responseData);
      } else {
        setScheduleStatus(null);
      }
    } catch (e) {
      setScheduleStatus(null);
    }
  }, [post, agentId]);

  return { scheduleStatus, checkSchedule };
}
